import { useMutation, useQueryClient } from '@tanstack/react-query'

import { del } from 'utils/http'

import { useCurrentUserId } from './useCurrentUserId'

export const useMfaReset = () => {
  const userId = useCurrentUserId()
  const queryClient = useQueryClient()

  const resetMfa = () => del(`/management/auth/users/${userId}/mfa`)

  return useMutation({
    mutationFn: resetMfa,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['mfa_setup'] }),
  })
}
